import React, { useEffect, useId, useState } from 'react';
import Select from 'react-select';
import StyledText from '../../app/components/styledComponents/StyledText';
import { productDefaultImage } from '../products/assets/productsUtil';

const AddOnsListView = ({
  addonList,
  selectedList,
  onChangeAddon,
  getAddOnPrice = () => {},
}) => {
  const [selectOption, setSelectOption] = useState([]);
  // const [selectedAddon, setSelectedAddon] = useState(product?.selectedAddon?.id)

  useEffect(() => {
    const optionList = [];
    for (let index = 0; index < addonList.length; index++) {
      const item = addonList[index];
      if (
        selectedList.find((obj) => obj?.addonsDto?.id === item?.id) ===
        undefined
      ) {
        optionList.push({
          label: (
            <div className="d-flex gap-2 align-items-center">
              <div style={{ width: '100px', height: '50px' }}>
                <img
                  alt=""
                  loading="lazy"
                  src={item?.imageUrl ?? productDefaultImage}
                  style={{ maxHeight: '50px', objectFit: 'contain' }}
                />
              </div>
              <div>
                <StyledText
                  as="h5"
                  $fontSize="20px"
                  color="heading"
                  $fontWeight="600"
                >
                  {item?.title}
                </StyledText>
                <StyledText
                  as="h5"
                  $fontSize="18px"
                  color="heading"
                  $fontWeight="400"
                >
                  ${getAddOnPrice(item)}
                </StyledText>
              </div>
            </div>
          ),
          value: item.id,
        });
      }
    }
    setSelectOption(optionList);
  }, [selectedList]);

  const selectAddonHandle = (e) => {
    // setSelectedAddon(e.value)
    const obj = addonList.find((data) => data?.id === e.value);
    onChangeAddon(obj);
  };

  return (
    <>
      <div className="bt-1 border-color-1 mt-30 mb-30"></div>
      <Select
        instanceId={useId()}
        className="btf-select-container"
        value={-1}
        options={selectOption}
        onChange={selectAddonHandle}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        }}
      />
    </>
  );
};

export default AddOnsListView;
